import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { WorkerDownloadCsvClientiModalComponent } from './worker-download-csv-clienti-modal';

export const WorkerDownloadCsvClientiModalModule: string = ng
    .module('worker-download-csv-clienti-modal', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('workerDownloadCsvClientiModalComponent', WorkerDownloadCsvClientiModalComponent)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/admin/worker-download-csv-clienti-modal/worker-download-csv-clienti-modal.module.ts